export enum Empty {
    GuidValue = '00000000-0000-0000-0000-000000000000',
    StringValue = ''
}


// WEBPACK FOOTER //
// ./src/app/models/utils.model.ts